import { isTopUpStatus } from '../policies/top-up-status.policy';
import { DispatchTopUp } from '../components/DispatchTopUp';
import { TripCashPanel } from '../components/TripCashPanel';

interface TripCashSectionProps {
  tripId: string;
  tripNumber: string;
  tripStatus: string;
  /** The crew's driver; null when none is assigned, so there is nobody to give cash to. */
  driver: { label: string } | null;
  canTopUp: boolean;
  canViewCash: boolean;
  canRecordCash: boolean;
  onChanged: () => void;
}

/** The money on a trip that has gone: add cash for the driver, and what was given against what was spent. Shared by the dispatch page and the trip page. */
export function TripCashSection({ tripId, tripNumber, tripStatus, driver, canTopUp, canViewCash, canRecordCash, onChanged }: TripCashSectionProps) {
  const canGiveTopUp = canTopUp && driver !== null && isTopUpStatus(tripStatus);
  return (
    <>
      {canGiveTopUp && <DispatchTopUp tripId={tripId} driverName={driver.label} onGiven={onChanged} />}
      {canViewCash && <TripCashPanel tripId={tripId} tripNumber={tripNumber} canRecord={canRecordCash} />}
    </>
  );
}
